import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';
import FilterButton from 'components/search_sidebar/filter_button';

import CheckboxGroupTags from 'components/search_page/checkbox_group_tags';
import CurrentFilters from 'components/search_page/current_filters';
import FilterRow from 'components/search_page/filter_row';
import BrokerFilter from 'components/search_sidebar/broker_filter';

import {
  changeAssignmentTypeFilter,
  changeBrokerFilter,
  changePropertyTypeFilter,
  changeStatusFilter,
  changeSearchText,
  clearFilters
} from './store/actions/query';

import { filterLabelMappings } from './assignment_filter_constants';

const assignmentTypes = [
  { id: 'buy', label: 'Buy', value: 'buy' },
  { id: 'lease', label: 'Lease', value: 'lease' },
  { id: 'both', label: 'Buy / Lease', value: 'both' }
];

export class AssignmentFilterTopbar extends React.Component {
  static propTypes = {
    assignmentCount: PropTypes.number.isRequired,
    assignmentTypeFilter: PropTypes.array.isRequired,
    brokerFilter: PropTypes.string,
    currentPage: PropTypes.number.isRequired,
    listingStatuses: PropTypes.array.isRequired,
    pageSize: PropTypes.number.isRequired,
    propertyTypeFilter: PropTypes.array.isRequired,
    propertyTypes: PropTypes.array.isRequired,
    searchText: PropTypes.string.isRequired,
    statusFilter: PropTypes.array.isRequired,
    totalCount: PropTypes.number.isRequired,
    onChangeAssignmentTypeFilter: PropTypes.func.isRequired,
    onChangeBrokerFilter: PropTypes.func.isRequired,
    onChangePropertyTypeFilter: PropTypes.func.isRequired,
    onChangeSearchText: PropTypes.func.isRequired,
    onChangeStatusFilter: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired
  };

  handleSearchChange = (e) => {
    this.props.onChangeSearchText(e.target.value);
  };

  handleCheckboxGroupChange = (e, name) => {
    const { checked, value } = e.target;
    const { filterKey, onChange } = this.filterMapping[name];
    const filter = [...this.props[filterKey]].filter(selected => selected !== value);
    if (checked) filter.push(value);

    onChange(filter);
  };

  handleAssignmentTypeChange = (e) => {
    this.handleCheckboxGroupChange(e, 'assignmentType');
  };

  handlePropertyTypeChange = (e) => {
    this.handleCheckboxGroupChange(e, 'propertyType');
  };

  handleStatusChange = (e) => {
    this.handleCheckboxGroupChange(e, 'status');
  };

  handleBrokerChange = (option) => {
    this.props.onChangeBrokerFilter(option.id ? option.id : null);
  };

  filterMapping = {
    assignmentType: {
      filterKey: 'assignmentTypeFilter',
      handleChange: this.handleAssignmentTypeChange,
      onChange: this.props.onChangeAssignmentTypeFilter,
      options: assignmentTypes
    },
    propertyType: {
      filterKey: 'propertyTypeFilter',
      handleChange: this.handlePropertyTypeChange,
      onChange: this.props.onChangePropertyTypeFilter,
      options: this.props.propertyTypes
    },
    status: {
      filterKey: 'statusFilter',
      handleChange: this.handleStatusChange,
      onChange: this.props.onChangeStatusFilter,
      options: this.props.listingStatuses
    }
  };

  render() {
    return (
      <div className="border-top border-bottom bg-light py-3">
        <div className="container-fluid">
          {this.renderFilters()}
          <CurrentFilters onClearFilters={this.props.onClearFilters}>
            {this.renderTags()}
          </CurrentFilters>
        </div>
      </div>
    );
  }

  renderFilters() {
    const { currentPage, assignmentCount, pageSize, searchText, totalCount } = this.props;
    const pageData = {
      currentPage,
      itemCount: assignmentCount,
      itemSingularLabel: 'assignment',
      pageSize,
      totalCount
    };

    return (
      <FilterRow
        pageData={pageData}
        searchPlaceholder="Search by title or address"
        searchText={searchText}
        onSearchChange={this.handleSearchChange}
      >
        {this.renderBrokerFilter()}
        {this.renderCheckboxGroupFilter('status')}
        {this.renderCheckboxGroupFilter('assignmentType')}
        {this.renderCheckboxGroupFilter('propertyType')}
      </FilterRow>
    );
  }

  renderBrokerFilter() {
    return (
      <div className="left-buffer-md">
        <BrokerFilter
          selectedBrokerId={this.props.brokerFilter}
          onChange={this.handleBrokerChange}
        />
      </div>
    );
  }

  renderCheckboxGroupFilter(name) {
    const { filterKey, handleChange, options } = this.filterMapping[name];
    const filter = this.props[filterKey];

    return (
      <FilterButton filtersApplied={filter.length > 0} label={filterLabelMappings[name]} name={name}>
        <FilterCheckboxGroup
          name={`${name}InputGroup`}
          options={options}
          selected={filter}
          onChange={handleChange}
        />
      </FilterButton>
    );
  }

  renderCurrentFilters() {
    const tags = this.renderTags();

    if (tags.length === 0) return null;

    return (
      <div className="top-buffer-xs">{tags}</div>
    );
  }

  renderTags() {
    const tags = [];
    this.renderCheckboxGroupTags(tags, 'status');
    this.renderCheckboxGroupTags(tags, 'assignmentType');
    this.renderCheckboxGroupTags(tags, 'propertyType');

    return tags;
  }

  renderCheckboxGroupTags(tags, name) {
    const { filterKey, handleChange, options } = this.filterMapping[name];
    const filter = this.props[filterKey];
    if (filter.length === 0) return;

    const label = filterLabelMappings[name];

    tags.push(
      <CheckboxGroupTags
        filter={filter}
        key={`${name}_tags`}
        label={label}
        name={name}
        options={options}
        onRemove={handleChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  ...state.search.meta,
  ...state.query,

  assignmentCount: state.search.assignments.length
});

const mapDispatchToProps = {
  onChangeAssignmentTypeFilter: changeAssignmentTypeFilter,
  onChangeBrokerFilter: changeBrokerFilter,
  onChangePropertyTypeFilter: changePropertyTypeFilter,
  onChangeStatusFilter: changeStatusFilter,
  onChangeSearchText: changeSearchText,
  onClearFilters: clearFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentFilterTopbar);
